import React from 'react';
import { RoundedUploadedFile, RegularUploadedFile, UploadedFileProps } from './UploadedFile';
import { ButtonProps, DashedButton, RegularButton } from './StyledButtons';

type ComponentsConfig = {
  wrapperClassNames?: string;
  FilesComponent: React.FC<UploadedFileProps>;
  ButtonComponent: React.FC<ButtonProps>;
};

export const Components: Record<string, ComponentsConfig> = {
  button: {
    wrapperClassNames: 'flex flex-1 flex-col gap-2 w-full',
    FilesComponent: RegularUploadedFile,
    ButtonComponent: RegularButton,
  },
  dashedButton: {
    wrapperClassNames: 'flex flex-row flex-wrap gap-2',
    FilesComponent: RoundedUploadedFile,
    ButtonComponent: DashedButton,
  },
};
